import request from '@/utils/request'

// 个人信息
// export function getUser() {
//   return request({
//     url: '/v2/client/customers/users/profiles',
//     method: 'get',
//   })
// }


// export function getEmailVerification(data) {
//   return request({
//     url: '/v2/public/customers/email/verification-codes',
//     method: 'post',
//     data
//   })
// }

// stripe公钥
export function getKey() {
  return request({
    url: '/v2/client/transactions-args',
    method: 'get',
  })
}

export function getOrder(data) {
  return request({
    url: '/v2/client/initiate-an-order', 
    method: 'post',
    // headers: { "Content-Type": "application/json" },
    data
  })
}

export function login(data) {
  return request({
    url: '/v2/public/customers/sms/login',
    method: 'post',
    data
  })
}
export function emailLogin(data) {
  return request({
    url: '/v2/public/customers/email/login',
    method: 'post',
    data
  })
}


// 登录相关
// 注册
export function register(data) {
  return request({
    url: '/api/user/account/register',
    method: 'post',
    data
  })
}
// 发送邮箱验证码
export function verificationCodes(data) {
  return request({
    url: '/api/user/email/verification-codes',
    method: 'post',
    data
  })
}
// 密码登录
export function login2(data) {
  return request({
    url: '/api/user/password/login',
    method: 'post',
    data
  })
}
// 重置密码
export function resetPassword(data) {
  return request({
    url: '/api/user/reset/password',
    method: 'post',
    data
  })
}
// 重置token
export function resetToken(data) {
  return request({
    url: '/api/user/reset/token',
    method: 'post',
    data
  })
}
// 发送短信验证码
export function verificationCodes2(data) {
  return request({
    url: '/api/user/sms/verification-codes',
    method: 'post',
    data
  })
}

// 统计相关
// 统计每日使用量
export function dailyDetail(data) {
  return request({
    url: '/api/stats/usage/daily-detail',
    method: 'post',
    data
  })
}
// 使用详情
export function usageDetail(data) {
  return request({
    url: '/api/stats/usage/detail',
    method: 'post',
    data
  })
}

// 支付相关
// 下单
export function getPayOrder(data) {
  return request({
    url: '/api/pay/order',
    method: 'post',
    data
  })
}
// stripe支付回调
export function getStripeCallback(data) {
  return request({
    url: '/api/pay/order/stripe-callback',
    method: 'post',
    data
  })
}

// 翻译相关
// web文本翻译
export function translateWeb(data) {
  return request({
    url: '/api/v1/index/translate',
    method: 'post',
    data
  })
}
// 文本多语言翻译
export function translateText(data) {
  return request({
    url: '/api/v1/text/multi-languages/translate',
    method: 'post',
    data
  })
}
// 文本批量翻译
export function batchTranslateText(data) {
  return request({
    url: '/api/v1/text/translate/batch',
    method: 'post',
    data
  })
}
// 语音翻译
export function translateSpeech(data) {
  return request({
    url: '/api/v1/speech/translate',
    method: 'post',
    data
  })
}
// 文本翻译
export function chatTranslate(data) {
  return request({
    url: '/api/v1/text/translate',
    method: 'post',
    data
  })
}

// 翻译记录
export function translateLogs(data) {
  return request({
    url: '/api/v1/text/translate/log',
    method: 'post',
    data
  })
}

// 基础配置相关
export function languageList(data) {
  return request({
    url: '/api/base/translate/language-list',
    method: 'post',
    data
  })
}

// 检查短信邮箱验证码
export function checkVerificationCode(data) {
  return request({
    url: '/api/user/verify/verification-code',
    method: 'post',
    data
  })
}

// 产品列表
export function productList(data) {
  return request({
    url: '/api/base/product/list',
    method: 'post',
    data
  })
}

// 首页价格
export function productPrices(data) {
  return request({
    url: '/api/base/product/home',
    method: 'post',
    data
  })
}

// 订单查询
export function getOrderStatus(data) {
  return request({
    url: '/api/pay/order/query',
    method: 'post',
    data
  })
}

// 语音翻译语言列表
export function getSpeechLanguageList(data) {
  return request({
    url: '/api/base/speech/language-list',
    method: 'post',
    data
  })
}

// 用户信息 
export function getUserInfo(data) {
  return request({
    url: '/api/user/info',
    method: 'post',
    data
  })
}